import styled from 'styled-components';
import { baseVariables, toRem } from '../../styles';

export const StyledTextComponent = styled.div`
  p {
    margin-bottom: 0;
  }
  .custom-styles {
    .m-link-tertiary-button-external,
    .m-link-tertiary-button-external::after,
    .m-link-action {
      font-size: inherit;
      line-height: inherit;
    }
  }
`;

export const CtaBlock = styled.div<{ textAlign: string }>`
  display: flex;
  gap: ${toRem(8)};
  align-items: ${props =>
    props.textAlign === 'center' ? 'center' : props.textAlign === 'left' ? 'flex-start' : 'flex-end'};
  flex-direction: column;
  font-size: ${toRem(16)};
  font-weight: 700;
  .m-link {
    padding-bottom: ${toRem(2)};
  }
  .m-link-action {
    font-size: inherit;
    font-weight: inherit;
    padding: 0 0 ${toRem(2)} 0;
  }
  .m-link-tertiary-button {
    padding: 0 0 ${toRem(2)} 0;
    font-size: inherit;
    font-weight: inherit;
  }

  @media ${baseVariables.mediaQuery.sm} {
    flex-direction: row;
    align-items: center;
    gap: ${toRem(16)};
  }
`;

export const DescriptionContainer = styled.div`
  .description-action-btn {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;

    .m-link-action {
      cursor: pointer;
    }
  }
`;
